module.exports = __webpack_public_path__ + "img/bg-banner.bf881139.png";